import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ConfigService } from '../../services/config-service';
import { ArcgisDomainService } from '../../services/arcgis-domain-service';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  const arcgisDomain = inject(ArcgisDomainService);
  if (arcgisDomain.isArcgisRequest(req.url)) {
    return next(req);
  }
  const config: ConfigService = inject(ConfigService);

  if (config.isProduction) return next(req);

  const start = Date.now();
  const method = req.method;
  const url = req.url;

  console.log(`[HTTP] → ${method} ${url}`);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - start;
          const level = duration > 5000 ? 'warn' : 'log';
        }
      },
      error: (error: HttpErrorResponse) => {
        const duration = Date.now() - start;
      },
    })
  );
};
